/**
 * Calculates the read time for content, defaulting to 5 minutes when the
 * value is 0 or falsy.
 *
 * The default value of 5 minutes was chosen as a reasonable minimum reading
 * time that provides better user experience than displaying "0 min read",
 * which can appear unprofessional or suggest missing content. This ensures
 * that even short articles show a meaningful read time estimate.
 *
 * The function uses Number() to convert the input, which handles various
 * edge cases:
 * - Number(undefined) returns NaN, which is falsy
 * - Number(null) returns 0, which triggers the default
 * - Number("0") returns 0, which triggers the default
 * - Number("") returns 0, which triggers the default
 * - Number("5") returns 5, preserving string number inputs
 * - Number(NaN) returns NaN, which is falsy and triggers the default
 *
 * @param minutes - The read time value from database
 * @returns The read time in minutes as a number, guaranteed to be at least 5
 */
function getReadTimeWithDefault(minutes) {
  var numberOfMinutes = Number(minutes);
  return numberOfMinutes > 0 ? numberOfMinutes : 5;
}

export { getReadTimeWithDefault };
